import { AlertColor } from "@mui/material";
import { create } from "zustand";

type SnackbarMessage = {
  message: string;
  type?: AlertColor;
};

type SnackbarStore = {
  queue: SnackbarMessage[];
  enqueue: (msg: SnackbarMessage) => void;
  dequeue: () => void;
};

export const useStackSnackbarStore = create<SnackbarStore>((set, get) => ({
  queue: [],
  enqueue: (msg) => {
    const queue = get().queue;
    const exists = queue.some(
      (q) => q.message === msg.message && q.type === msg.type
    );
    if (exists) return;

    set((state) => ({
      queue: [...state.queue, msg].slice(-3),
    }));
  },
  dequeue: () =>
    set((state) => ({
      queue: state.queue.slice(1),
    })),
}));
